import { BsCurrencyDollar, BsShield } from 'react-icons/bs';
import { FiCreditCard } from 'react-icons/fi';

export const userProfileData = [
    {
        icon: <BsCurrencyDollar />,
        title: 'Mi perfil',
        desc: 'Account Settings',
        iconColor: '#03C9D7',
        iconBg: '#E5FAFB',
    },
    {
        icon: <BsShield />,
        title: 'My Inbox',
        desc: 'Messages & Emails',
        iconColor: 'rgb(0, 194, 146)',
        iconBg: 'rgb(235, 250, 242)',
    },
    {
        icon: <FiCreditCard />,
        title: 'My Tasks',
        desc: 'To-do and Daily Tasks',
        iconColor: 'rgb(255, 244, 229)',
        iconBg: 'rgb(254, 201, 15)',
    },
];
export const days = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28,
];
export const smsN = ['Desactivado', 'Correo', 'SMS', 'Telegram', 'Correo + Telegram' + '+ SMS'];

export const usosCFDI = [
    { clave: 'G01', des: 'Adquisición de mercancías' },
    { clave: 'S01', des: 'Sin efectos fiscales' },
    { clave: 'G02', des: 'Devoluciones, descuentos o bonificaciones' },
    { clave: 'G03', des: 'Gastos en general' },
    { clave: 'I01', des: 'Construcciones' },
    { clave: 'I02', des: 'Mobiliario y equipo de oficina por inversiones' },
    { clave: 'I03', des: 'Equipo de transporte' },
    { clave: 'I04', des: 'Equipo de cómputo y accesorios' },
    { clave: 'I05', des: 'Datos, troqueles, moldes, matrices y herramental' },
    { clave: 'I06', des: 'Comunicaciones telefónicas' },
    { clave: 'I07', des: 'Comunicaciones satelitales' },
    { clave: 'I08', des: 'Otra maquinaria y equipo' },
    { clave: 'D01', des: 'Honorarios médicos, dentales y gastos hospitalarios' },
    { clave: 'D02', des: 'Gastos médicos por incapacidad o discapacidad' },
    { clave: 'D03', des: 'Gastos funerales' },
    { clave: 'D04', des: 'Donativos' },
    {
        clave: 'D05',
        des: 'Intereses reales efectivamente pagados por créditos hipotecarios (cada habitación)',
    },
    { clave: 'D06', des: 'Aportaciones voluntarias al SAR' },
    { clave: 'D07', des: 'Primas por seguros de gastos médicos' },
    { clave: 'D08', des: 'Gastos por transportación escolar obligatoria' },
    {
        clave: 'D09',
        des: 'Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones',
    },
    { clave: 'D10', des: 'Pagos por servicios educativos (colegiaturas)' },
];
export const formatData = (data) => {
    const { wirelessData, wiredData, networkData } = data;

    // Formatear datos inalámbricos
    const formattedWirelessData = wirelessData.map((item) => {
        const [id, device, ip, mac] = item.split(' | ');
        return { id: id || '--', device: device || 'No disponible' };
    });

    // Formatear datos cableados
    const formattedWiredData = wiredData.map((item) => {
        const [id, device, ip, mac] = item.split(' | ');
        return { id: id || '--', device: device || 'No disponible' };
    });

    // Formatear datos de red
    const formattedNetworkData = {
        ssid2_4GHz: networkData[0]?.split(': ')[1] || 'No disponible',
        password2_4GHz: networkData[1]?.split(': ')[1] || 'No disponible',
        ssid5GHz: networkData[2]?.split(': ')[1] || 'No disponible',
        password5GHz: networkData[3]?.split(': ')[1] || 'No disponible',
    };

    return {
        wirelessData: formattedWirelessData,
        wiredData: formattedWiredData,
        networkData: formattedNetworkData,
    };
};

export const filterMenu = (menuItems, accessList) => {
    return menuItems
        .filter((menu) => {
            const permission = accessList.find((acc) => acc.menu === menu.label);
            return permission?.access !== false && menu.show !== false;
        })
        .map((menu) => {
            const permission = accessList.find((acc) => acc.menu === menu.label);

            let children = menu.children;

            if (permission?.sub !== false && permission?.submenus) {
                children = children?.filter((child) =>
                    permission.submenus.some((sub) => sub.name === child.label && sub.access !== false)
                );
            } else {
                children = undefined;
            }

            return {
                ...menu,
                ...(children && children.length > 0 ? { children } : {}),
            };
        });
};
